(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusControllers')
        .controller('ActionPlanUpdateStatusOwnersListController', Controller);

    Controller.$inject = ['$scope', '$state', '$filter', '$modal', 'topBarService', 'actionPlanLookups', 'owners', 'recomActionPlanUpdateStatusService',
        'businessUnit', 'activeProcess', 'recomService', 'notificationService', 'grcActionPlanService'];

    function Controller($scope, $state, $filter, $modal, topBarService, actionPlanLookups, owners, recomActionPlanUpdateStatusService,
                        businessUnit, activeProcess, recomService, notificationService, grcActionPlanService) {

        var title = businessUnit.TitleEN + ' Action Plans | ' + activeProcess.ShortName + ' Progress Tracking';
        topBarService.setTitleAndIcon(title, 'fa fa-road');

        $scope.activeProcess = activeProcess;
        $scope.businessUnit = businessUnit;
        $scope.closingProcess = false;

        var ownersByStatus = _.groupBy(owners, 'OwnerStatusValue');

        $scope.allStatus = _.map(actionPlanLookups.ActionPlanProgressStatuses, function (status) {
            status.items = ownersByStatus[status.Value];
            status.displayedItems = ownersByStatus[status.Value];
            return status;
        });
        $scope.view = {};

        // Toggle filter status selection
        $scope.toggleFilterStatusSelection = function (status) {
            $scope.selectedStatus = $scope.selectedStatus === status ? null : status;
        };

        // Is Status Active?
        $scope.isStatusActive = function (status) {
            if (!$scope.selectedStatus) return undefined;
            return $scope.selectedStatus.Value === status.Value;
        };

        // Get Status Css Classes
        $scope.getStatusCssClasses = function (status) {
            var classes = status.CssClasses;

            if ($scope.isStatusActive(status)) {
                classes += ' is-active';
            }

            return classes;
        };
    
        // Check GovernanceProcess
        $scope.validateBusinessUnit = function () {
            recomService
                .validateBusinessUnit(businessUnit.RecomBusinessUnitID)
                .then(function (recomBusinessUnitValidationErrors) {

                    // Modal to show
                    var modalScope = $scope.$new(true);
                    modalScope.businessUnit = businessUnit;
                    modalScope.recomBusinessUnitValidationErrors = recomBusinessUnitValidationErrors;

                    // Get Action Plans
                    // TODO: display the modal only when all Action Plans are fetched and fetch each once only
                    _.each(recomBusinessUnitValidationErrors, function (validationError) {
                        if (validationError.RecomActionPlanCriteria) {
                            var criteria = validationError.RecomActionPlanCriteria;
                            grcActionPlanService
                                .getActionPlan(criteria.ActionPlanID)
                                .then(function (actionPlan) {
                                    criteria.ActionPlan = actionPlan;
                                });
                        }
                    });
                    
                    var showModal = $modal({
                        scope: modalScope,
                        template: '/app/Main/recomActionPlanStatusUpdate/actionPlanUpdateStatusValidateModal.tpl.html',
                        placement: 'center'
                    });

                    modalScope.hideModal = function () {
                        showModal.$promise.then(showModal.hide);
                    };

                    modalScope.okModal = function () {
                        modalScope.hideModal();
                    };

                    // Go to Action Plan Criteria
                    modalScope.goToActionPlanCriteria = function (actionPlanCriteria) {
                        modalScope.hideModal();
                        $state.go('recommendation.edit.actionPlan.edit.actionPlanCriteriaEdit', {
                            RecommendationID: actionPlanCriteria.ActionPlan.RecommendationID,
                            ActionPlanCriteriaID: actionPlanCriteria.ActionPlanCriteriaID,
                            ActionPlanID: actionPlanCriteria.ActionPlanID
                        });
                    };

                    // Go to Action Plan
                    modalScope.goToActionPlan = function (actionPlan) {
                        modalScope.hideModal();
                        $state.go('recommendation.edit.actionPlan.edit', {
                            RecommendationID: actionPlan.RecommendationID,
                            ActionPlanID: actionPlan.ActionPlanID
                        });
                    }

                });
        };


        $scope.closeGovernanceProcess = function () {
            $scope.activeProcess.IsActive = false;
            $scope.closingProcess = true;
            recomService
                .updateGovernanceProcess($scope.activeProcess)
                .then(function (updatedGovernanceProcess) {
                    notificationService.notify('The Governance Process was closed');

                    if (!updatedGovernanceProcess.IsActive) {
                        $state.go('home', { UserItemPersonID: $scope.authenticatedUser.ItemPersonID }, { reload: true });
                    }
                })
                .finally(function () {
                    $scope.closingProcess = false;
                });
        };


        // Clear Filter
        $scope.clearFilter = function () {
            $scope.selectedStatus = null;
        };

        // Search
        $scope.searchOwners = function (q) {
            var columnsToSearch = ['DisplayName', 'EmployeePositionEN', 'EmployeeDepartmentEN', 'EmployeeEmail'];

            _.forEach($scope.allStatus, function (status) {
                status.displayedItems = $filter('filterBy')(status.items, columnsToSearch, q);
            });
        };
    }
})();